import { useMemo } from "react";
import { MakeRow } from "./components/MakeRow";
import { ScoreMarkEnum } from "../../api/enums/leaderboard-enums";
import { BPLeaderboardItem } from "../../api/interfaces/BPleaderboard-item.interface";
import styles from "../TableData/styles.module.css";

interface ITableDataProps {
  size: number;
  items: BPLeaderboardItem[];
  marks: ScoreMarkEnum[];
}

export function TableData({ size, items, marks }: ITableDataProps) {
  const emptyRowCount = useMemo(() => {
    return size - items.length;
  }, [items.length, size]);

  return (
    <div className={styles.table}>
      {items.map((item, index) => {
        return (
          <MakeRow
            key={index === 0 ? "header_row" : `${index}_general_row`}
            item={item}
            marks={marks}
            index={index}
          />
        );
      })}

      {emptyRowCount > 0 &&
        [...Array(emptyRowCount)].map((irr, index) => {
          const rank = index + items.length;
          return (
            <MakeRow
              key={`${rank}_empty_row`}
              item={null}
              marks={marks}
              index={rank}
            />
          );
        })}
    </div>
  );
}
